import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../components/Common/const'
import { Field, Form, Formik } from 'formik';
import { VehicleContext } from '../components/Context/VehicleContext';
import "react-range-slider-input/dist/style.css";
import Slider from "react-slick";
import MyVehicleForm from '../components/SameDayOffers/MyVehicleForm';
import ModalLayout from '../components/Common/ModalLayout';
import GetQuoteModal from '../components/SameDayOffers/GetQuoteModal';
import PhotoUploadModal from '../components/SameDayOffers/PhotoUploadModal';

const carData = [
    {
        image: 'srp-img2.webp',
        vehicle_name: '1972 Ferrari Dino 246 GTB',
        price: '$519,777',
        mileage: '3,767mi',
    },
    {
        image: 'srp-img3.webp',
        vehicle_name: '2015 Ferrari 458 Italia',
        price: '$479,888',
        mileage: '11,682mi',
    },
    {
        image: 'srp-img4.webp',
        vehicle_name: '2023 Rolls-Royce Phantom',
        price: '$478,777',
        mileage: '7,194mi',
    },
    {
        image: 'srp-img5.webp',
        vehicle_name: '1969 Chevrolet Camaro SS',
        price: '$382,777',
        mileage: '8,030mi',
    },
    {
        image: 'srp-img6.webp',
        vehicle_name: '2021 Chevrolet Corvette',
        price: '$359,888',
        mileage: '3,026mi',
    },
]
const reviews = [
    {
      name: "Carlos Landaeta Q",
      content:
        "I had a wonderful experience buying my car, and I couldn't be more grateful for the support I received. From the moment I first saw the car, Chandler was incredibly professional and attentive. He guided me through every step of the financial process and made the delivery seamless. They truly made the entire experience easy and stress-free, and I appreciate all their efforts!",
    },
    {
      name: "L Portugal",
      content:
        "Excellent Service! Thank you Mario & Steven for making my Lamborghini transaction super fast! Highly recommend Mark Motors for their wide selection of exotic vehicles. Couldn’t be happier with my selection.",
    },
    {
      name: "John",
      content:
        "I recently had my Cyber Truck wrapped and windows tinted at Mark Motors, and I couldn't be happier with the results! The team was incredibly efficient and took the time to explain every detail of the process, ensuring I was informed and comfortable throughout. The quality of the completed work was flawless—from the wrap to the window tinting, everything looks amazing. Not only did they surpass my expectations in terms of craftsmanship, but their customer service was also outstanding. They truly went above and beyond to make sure I was satisfied. I highly recommend Mark Motors for anyone looking to customize their vehicle. You won't be disappointed! Jeff M Fredericksburg, Texas",
    },
    {
      name: "Andrew Hernandez",
      content:
        "This is my 2nd deal with MM in 8 months. Not sure how or where these 1 star reviews are coming from, but I'm thinking there are accountability issues with those individuals. My boy Nathan got me hooked up with this beast G550 4x4. From the initial text to source the vehicle, to delivery took less than a month. Paperwork took less than 15min with Steve. Everything again was upfront and transparent. There was an issue with a leaky shock after delivery, which is inevitable for a 7 year old car with 10k miles. One text and 30min later and the issue is being taken care of with white glove service. For anyone, especially those buying out of town, you can buy with confidence when buying with these guys.",
    },
    {
      name: "JOANNA GROSHANS",
      content:
        "We have bought and sold several cars with Nathan at Mark's Motors. Excellent customer service and their vehicles are always top tier. From start to finish it is seamless. Thank you for what you offer your customers. 100% recommend.",
    },
    {
      name: "Alex ASF Trans",
      content:
        "It's easy to choose a two-door friend for yourself! High professionals! Respect! Recommend!",
    },
    {
      name: "Jessica Norcross",
      content:
        "Absolutely love Mark Motors! In a difficult market, Gerardo searched high and low to find me a new car. Justin w/Mark Customs took my new, ordinary Escalade and turned it into my dream car. It’s gorgeous and exactly what I was hoping for! Their Customer Service is top notch and my family and I plan to be life-long customers.",
    },
    {
      name: "Donovan Greenlee",
      content:
        "My review goes out to the Mark Motors Customs' team (Jennifer, Justin, Kirk, and others). The customs team has performed several jobs on my C8 corvette. They have installed tints, a carbon fiber rear spoiler, installed aftermarket wheels, and recently repaired my paint after it sustained heavy rock chip damage (over 40 chips in the paint). Each job they have performed, was done at a phenomenal level. Even Chevrolet told me that they themselves wouldn't be able to repair the damage completely and that the chips would still be noticeable. The Customs team at Mark Motors did beyond that and repaired the paint to 110 percent. Nothing from the rock chips remained. The bumper looks completely brand new. The PPF they installed afterward is also barely noticeable. I could barely make out the edges of the PPF because of how close they got it to the perimeter of my front bumper. Big thanks to the team for their work and their communication with me throughout the days of service.",
    },
  ];
  
const SameDayOffers = () => {
    const {getVehicleData, numberFormatter, featuredVehicles } = useContext(VehicleContext);
    var srpCarSlider = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        centerPadding: '120px',
        arrows: true,
        dots: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const googleReviewLink = "https://www.google.com/search?client=firefox-b-d&sca_esv=4c75ca2344971d57&sxsrf=AHTn8zrXLSulgua0mTGex92jwZEQfrnmAw:1744311051147&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzdH8B6cLDEUVopuZzUUDA0BqM7_hZWYqBAOJKfCXUcv35GvEWOaOpM2RdG4GXaLOQIbU3mCXbAWnvRGl80eDM1YgqzYY&q=Mark+Motors+Reviews&sa=X&ved=2ahUKEwijktOEkc6MAxW8UWcHHczWGe4Q0bkNegQIMxAE&biw=1536&bih=731&dpr=1.25&sei=JxP4Z6W0AayK4-EP6rOBCQ";
    
    const [selectedValue, setSelectedValue] = useState("");
    const [getQuoteModal, setGetQuoteModal] = useState(false);
    const closeGetQuoteModal = () => {
        setGetQuoteModal(false)
    }
    const [openDragDropModal, setopenDragDropModal] = useState(false);
    const [previewURL, setPreviewURL] = useState(null);
    console.log("openDragDropModal", openDragDropModal)
    console.log("previewURL", previewURL)
    const closeDragDropModal = () => {
        setopenDragDropModal(false)
    }
    const [files, setFiles] = useState([]);

    useEffect(() => {
        console.log("home page useEffect");
        getVehicleData();

    }, []);
    return (
        <>
            <section className='common-banner-wrap mob-h-240 position-relative'>
                <img src={getImages('same-day-offers.webp')} />
                <div className='cb-pos'>
                    <div className='xl-title text-uppercase mb-3 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">SAME DAY OFFERS</div>
                    <div className='lg-title font-2-5em text-uppercase text-center fw-400 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.8s">Enjoy our stress-free process</div>
                </div>
            </section>
            <section className='hassle-process-wrap'>
                <div className='container'>
                    <div className='hassle-process-box d-flex wow fadeIn' data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className='hpb-left w-50'>
                            <div className='hpb-xs-title text-uppercase mb-2 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Call or text</div>
                            <div className='text-center'>
                                <a href='tel:8309815050' className='md-title call-text-title font-2-5em wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">830-981-5050</a>
                            </div>
                            <div className='md-title text-center fw-400 text-uppercase my-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.7s">How Our Process Works</div>
                            <div className='hpb-process-list'>
                                <div className='d-flex align-items-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.9s">
                                    <div className='hpb-circle me-3'>1</div>
                                    <div className='xs-title font-1-1em fw-400 text-uppercase'>Send in your vehicle information</div>
                                </div>
                                <div className='d-flex align-items-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="1s">
                                    <div className='hpb-circle me-3'>2</div>
                                    <div className='xs-title font-1-1em fw-400 text-uppercase'>Quickly receive an estimate</div>
                                </div>
                                <div className='d-flex align-items-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="1.1s">
                                    <div className='hpb-circle me-3'>3</div>
                                    <div className='xs-title font-1-1em fw-400 text-uppercase'>Finalize with our friendly agents</div>
                                </div>
                            </div>
                        </div>
                        <div className='hpb-right w-50'>
                            <div className='lg-title text-uppercase text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">NO HASSLE <br />PROCESS</div>
                            {/* <Formik
                                initialValues={{
                                    vehicleInfo: '',
                                }}
                                onSubmit={async (values, { resetForm }) => {
                                    console.log(values);
                                }}
                            >
                                {({ values, setFieldValue, field, form }) => (
                                    <Form className="custom-form contact-form offer-form mt-70" autoComplete="off">
                                        <div className='form-group wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                                            <div className='cs-label mb-2'>Enter your vehicle info</div>
                                            <Field type="text" name="vehicleInfo" className="form-control" placeholder="Year Make Model Trim or VIN" />
                                        </div>
                                        <div className='wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.7s">
                                            <button className="btn-theme text-gray w-100 d-inline-block" type='button'>GET My Value</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik> */}
                            <MyVehicleForm 
                                setSelectedValue={setSelectedValue}
                                getQuoteModal={getQuoteModal}
                                setGetQuoteModal={setGetQuoteModal}
                            />
                            <div className='sm-title text-center mt-90 fw-500 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.9s">Simple, Fast & Free</div>
                            <div className='text-center pt-3 wow fadeInUp' data-wow-duration="1s" data-wow-delay="1s">
                                <span className='px-88 d-inline-block hpb-border-t pt-3'>
                                    <img src={getImages('tg-logo-bw.png')} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='deals-wrap'>
                <div className='hpb-xs-title text-uppercase mb-2 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">TRADE UP FOR THE</div>
                <div className='md-title text-center font-2-5em mb-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">HOTTEST DEALS</div>
                <div className='deals-block wow fadeIn' data-wow-duration="1s" data-wow-delay="0.7s">
                                {/* {console.log("featuredVehicles", featuredVehicles)} */}
                        {featuredVehicles && (
                            <Slider className='deals-slider' {...srpCarSlider}>
                                {featuredVehicles.map((item, index) => (
                                    <div key={index} className='deal-col'>
                                        <div className='inner'>
                                            <article className="cs-card cs-card--2 fv-box">
                                                <div className="cs-card__img fv-top"
                                                    style={{
                                                        backgroundImage: `url(${item.images[0]})`,
                                                    }}
                                                ></div>
                                                <a href={`/vehicle-details/${item.vdp_url ?? `used-${item.vin}`}`} target='_blank' className="cs-card_link">
                                                    <div className="cs-card__img--hover fv-top"
                                                        style={{
                                                            backgroundImage: `url(${item.images[0]})`,
                                                        }}></div>
                                                </a>
                                                <div className="fv-bottom">
                                                    <div className="sm-title text-white font-bold deal-main-title">{item.year} {item.make} {item.model}</div>
                                                    <div className="d-flex align-items-end justify-content-between mt-1">
                                                        <div className="sm-title">{numberFormatter(item.price, true)}</div>
                                                        <div className="sm-title opacity-0-7 font-1em">{numberFormatter(item.mileage)}</div>
                                                    </div>
                                                    <div className='mt-3'>
                                                        <a href={`/vehicle-details/${item.vdp_url ?? `used-${item.vin}`}`} target='_blank' className='btn-theme text-gray w-100 d-inline-block'>Check Availability</a>
                                                    </div>
                                                </div>
                                            </article>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        )}
                    {/* <Slider className='deals-slider' {...srpCarSlider} >
                        {carData.map((car, index) =>
                            <div key={index} className='deal-col'>
                                <div className='inner'>
                                    <article className="cs-card cs-card--2 fv-box">
                                        <div className="cs-card__img fv-top"
                                            style={{
                                                backgroundImage: `url(${getImages(car.image)})`,
                                            }}
                                        ></div>
                                        <a href={`/vehicle-details/${car.vdp_url ?? `used-${car.vin}`}`} target='_blank' className="cs-card_link">
                                            <div className="cs-card__img--hover fv-top"
                                                style={{
                                                    backgroundImage: `url(${getImages(car.image)})`,
                                                }}></div>
                                        </a>
                                        <div className="fv-bottom">
                                            <div className="sm-title text-white font-bold deal-main-title">{car.vehicle_name}</div>
                                            <div className="d-flex align-items-end justify-content-between mt-1">
                                                <div className="sm-title">{numberFormatter(car.price, true)}</div>
                                                <div className="sm-title opacity-0-7 font-1em">{numberFormatter(car.mileage)}</div>
                                            </div>
                                            <div className='mt-3'>
                                                <a href={`/vehicle-details/${car.vdp_url ?? `used-${car.vin}`}`} target='_blank' className='btn-theme text-gray w-100 d-inline-block'>Check Availability</a>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        )}
                    </Slider> */}
                </div>
            </section>
            <section className='sell-or-trade-wrap wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.7s">
                <div className='container'>
                    <div className='d-flex align-items-center justify-content-between sot-flex'>
                        <div>
                            <div className='mb-2'>
                                <img src={getImages('tg-logo-bw.png')} />
                            </div>
                            <div className='md-title text-start font-2-2em'>Sell or Trade your Vehicle</div>
                        </div>
                        <div className='sot-right'>
                            {/* <Formik
                                initialValues={{
                                    vehicleInfo: '',
                                }}
                                onSubmit={async (values, { resetForm }) => {
                                    console.log(values);
                                }}
                            >
                                {({ values, setFieldValue, field, form }) => (
                                    <Form className="custom-form contact-form offer-form" autoComplete="off">
                                        <div className='cs-label mb-2'>Enter your vehicle info</div>
                                        <div className='d-flex align-items-center'>
                                            <Field type="text" name="vehicleInfo" className="form-control me-4" placeholder="Year Make Model Trim or VIN" />
                                            <button className="btn-theme text-gray d-inline-block px-3 text-nowrap" type='button'>GET My Value</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik> */}
                            
                            <MyVehicleForm 
                                setSelectedValue={setSelectedValue}
                                getQuoteModal={getQuoteModal}
                                setGetQuoteModal={setGetQuoteModal}
                                sotForm={true}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className='reviews-wrap'>
                <div className='container'>
                    <div className='hpb-xs-title text-uppercase mb-2 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Recent</div>
                    <div className='md-title text-center font-2-5em fw-500 text-uppercase mb-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">Google Reviews</div>
                    <div className=' wow fadeIn' data-wow-duration="1s" data-wow-delay="0.7s">
                        <Slider ref={sliderRef} {...settings} className='testimonial-slider review-slider'>
                            {reviews.map((review, index) => {
                                const wordCount = review.content.split(" ").length;
                                const showReadMore = wordCount > 45;
                                const truncatedContent = review.content.split(" ").slice(0, 45).join(" ") + "...";
                                return (
                                    <div className="review-item" key={index}>
                                        <div className="review-box">
                                            <div className="google-icon">
                                                <img src={getImages("icon-google-user.png")} alt="quote" />
                                            </div>
                                            <div className='review-mnh'>
                                                <p>
                                                    {showReadMore ? (
                                                        <>
                                                            {truncatedContent}{" "}
                                                            <a href={googleReviewLink} target="_blank" rel="noopener noreferrer">
                                                                Read More
                                                            </a>
                                                        </>
                                                    ) : (
                                                        review.content
                                                    )}
                                                </p>
                                            </div>
                                            <div className="d-flex align-items-end justify-content-between mt-3">
                                                <div>
                                                    <div className="mb-2 d-flex align-items-center">
                                                        {[...Array(5)].map((_, i) => (
                                                            <img key={i} className="me-1" src={getImages("star.svg")} alt="star" />
                                                        ))}
                                                    </div>
                                                    <div className="xs-title text-white">{review.name}</div>
                                                </div>
                                                <div>
                                                    <div className="quote-icon mb-2">
                                                        <img src={getImages("quote-shape.png")} alt="quote" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </section>
            {/* <section className='what-are-wrap'>
                <div className='container'>
                    <div className='hpb-xs-title text-uppercase mb-2 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">WHAT ARE THE</div>
                    <div className='md-title text-center font-2-5em fw-500 text-uppercase mb-100 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Most in Demand Vehicles?</div>
                    <div className='row'>
                        <div className='col-lg-3 col-md-6 col-sm-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                            <div className='wat-box'>
                                <div className='wat-image'>
                                    <img src={getImages('ferrari-488.png')} />
                                </div>
                                <div className='sm-title fw-500 mb-1'>Ferrari 488</div>
                                <div className='xxs-title opacity-0-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6 col-sm-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                            <div className='wat-box'>
                                <div className='wat-image'>
                                    <img src={getImages('mercedes-g-63.png')} />
                                </div>
                                <div className='sm-title fw-500 mb-1'>Mercedes G63</div>
                                <div className='xxs-title opacity-0-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6 col-sm-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.7s">
                            <div className='wat-box'>
                                <div className='wat-image'>
                                    <img src={getImages('porsche-911.png')} />
                                </div>
                                <div className='sm-title fw-500 mb-1'>Porsche 911</div>
                                <div className='xxs-title opacity-0-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6 col-sm-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.8s">
                            <div className='wat-box'>
                                <div className='wat-image'>
                                    <img src={getImages('corvertte.png')} />
                                </div>
                                <div className='sm-title fw-500 mb-1'>Chevy Corvette</div>
                                <div className='xxs-title opacity-0-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className='trading-wrap'>
                <div className='container'>
                    <div className='md-title text-center font-2-5em fw-500 text-uppercase mb-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Tips on Trading or Selling Your Vehicle</div>
                    <div className='wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                        <p>To find the right buyer for your used car, starting with a professional vehicle appraisal is a smart move. While several exotic car buyers operate in the market, partnering with a reputable company is key. Established dealerships in the United States adhere to specific standards and regulations, offering a level of assurance that individual buyers may not provide.</p>

                        <p>We specialize in purchasing exotic vehicles, drawing upon our team's extensive experience in the high-end automotive market. When selecting a used car buyer, prioritize expertise and a proven track record. Following your car appraisal, you can efficiently move forward to receive a cash offer or explore trade-in options for your vehicle.</p>
                    </div>
                </div>
            </section>
            <ModalLayout open={getQuoteModal} close={closeGetQuoteModal} darkThemeCls='true' modalWidth={750}>
                <GetQuoteModal 
                    selectedValue={selectedValue}
                    close={closeGetQuoteModal}
                    setopenDragDropModal={setopenDragDropModal}
                    setPreviewURL={setPreviewURL}
                    files={files}
                    setFiles={setFiles}
                />
            </ModalLayout>
            <ModalLayout open={openDragDropModal } close={closeDragDropModal} darkThemeCls='true' modalWidth={750}>
                <PhotoUploadModal 
                    close={closeDragDropModal}
                    previewURL={previewURL}
                    setPreviewURL={setPreviewURL}
                    files={files}
                    setFiles={setFiles}
                />
            </ModalLayout>
        </>
    )
}

export default SameDayOffers